import './i18n' // Must be first to initialize i18n before any components
import './App.css'
import {Root} from "./components/main-layout/root";
import {UserProvider} from "./context/use-auth";
import {Toaster} from "@/components/ui/toaster.tsx";

export default function App() {

    return (
        <>
            <UserProvider>
                <Root/>
            </UserProvider>
            <Toaster/>
        </>

    )
}
